import React, {useEffect, useState} from "react";
import {useStyles} from "./styles/PushStyle";
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {useHistory} from "react-router-dom";
import {
    Box,
    Button,
    Card,
    FormControl, FormControlLabel,
    MenuItem,
    Modal,
    Select, Switch,
    Tab,
    Tabs, TextField,
    Typography
} from "@material-ui/core";
import {makeStyles} from '@material-ui/core/styles';
import clsx from "clsx";
import {USER_TYPE} from "../../../stores/UserStore";
import {PushType, TabType} from "../../../stores/PushStore";
import {ReactComponent as ArrowLeftIcon} from "../../../common/images/ArrowLeftIcon.svg";
import {ReactComponent as ArrowDownIcon} from '../../../common/images/ArrowDownIcon.svg';
import {ReactComponent as TranslationRefreshIcon} from '../../../common/images/TranslationRefreshIcon.svg';
import PropTypes from "prop-types";
import {NoticeLangName} from "../../../common/enums/ContentEnum";
import {URL_TYPE} from "../../../routes/Routes";
import {NotificationType} from "../../../stores/NoticeStore";


function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const pickerStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));

function PushDetail(props) {
    const classes = useStyles();
    const pickerClasses = pickerStyles();
    const history = useHistory();
    const {authStore, pushStore, localeStore, groupStore} = props;
    const {intl} = props;
    const pushId = props.match.params.pushId;
    const userType = props.authStore.getUserType();
    const [openAlert, setOpenAlert] = useState(false);
    const [tabnum, setTabnum] = React.useState(0);
    const [checked, setChecked] = useState(true);

    useEffect(() => {
        groupStore.initLocaleGroup();
        pushStore.setCurrentTab(TabType.title)
        if (pushId > 0) {
            pushStore.getPushContents(pushId, localeStore.locale.toUpperCase(), (localeCode) => {
                groupStore.getLocalGroups(localeCode);
            },
            () => {
                history.push(URL_TYPE.Push);
            })
        } else {
            pushStore.initPushDetail();
        }
        if (userType === USER_TYPE.LocaleAdmin) {
            pushStore.setSelectOption(NotificationType.Locale);
            pushStore.setSelectLocale(props.authStore.loginUser.localeCode);
            groupStore.getLocalGroups(props.authStore.loginUser.localeCode);
            pushStore.setSelectGroupId(PushType.All);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localeStore.locale]);


    const LocaleList = [
        {value: PushType.Select, label: intl.formatMessage({id: "select"})},
        {value: 'US', label: intl.formatMessage({id: "US"})},
        {value: 'KR', label: intl.formatMessage({id: "KR"})},
        {value: 'JP', label: intl.formatMessage({id: "JP"})},
        {value: 'CN', label: intl.formatMessage({id: "CN"})},
        {value: 'TH', label: intl.formatMessage({id: "TH"})},
        {value: 'VN', label: intl.formatMessage({id: "VN"})},
        {value: 'MN', label: intl.formatMessage({id: "MN"})},
        {value: 'ID', label: intl.formatMessage({id: "ID"})},
        {value: 'RU', label: intl.formatMessage({id: "RU"})},
        {value: 'TW', label: intl.formatMessage({id: "TW"})},
        {value: 'ETC', label: intl.formatMessage({id: "ETC"})},
    ]

    const handleChangeCheck = () => {
        setChecked(!checked);
        pushStore.setReservationDatetime("");
    };

    const handleDeletePush = async () => {
        await pushStore.deletePush(pushId);
        setOpenAlert(false);
        history.push(URL_TYPE.Push);
    }

    const handleOpenDelete = () => {
        setOpenAlert(true);
    };

    const handleCloseDelete = () => {
        setOpenAlert(false);
    };

    const handleChangeLocale = (e) => {
        pushStore.setSelectLocale(e.target.value);
        pushStore.setSelectOption(PushType.Locale)
        groupStore.getLocalGroups(e.target.value);
        pushStore.setSelectGroupId(PushType.All);
    }

    const handleChangeGroup = (e) => {
        if (pushStore.selectLocale === PushType.Select) {
            alert(`${intl.formatMessage({id: "SelectAlert"})}`);
        } else {
            pushStore.setSelectGroupId(e.target.value);
            if (e.target.value !== PushType.All) {
                pushStore.setSelectOption(PushType.Group);
            }
        }
    }

    const handleChangeTitle = (event) => {
        const value = event.target.value;
        if (value.length <= 30) {
            pushStore.setTitle(value);
        }
    }

    const handleChangeSubtitle = (event) => {
        const value = event.target.value;
        if (value.length <= 30) {
            pushStore.setSubtitle(value);
        }
    }

    const handleChangeTab = (event, newValue) => {
        setTabnum(newValue);
        if (newValue === 0) {
            pushStore.setCurrentTab(TabType.title);
        } else if (newValue === 1) {
            pushStore.setCurrentTab(TabType.subTitle);
        }
    };

    const handleTextChange = (event, translation) => {
        const newText = event.target.value;
        translation[pushStore.currentTab] = newText;
    };

    const handleReservationDatetime = (event) => {
        pushStore.setReservationDatetime(event.target.value);
    }

    const translateAll = () => {
        const lang = localeStore.locale.toUpperCase();
        let text = "";
        if (pushStore.currentTab === TabType.title) {
            text = pushStore.title;
        } else {
            text = pushStore.subtitle;
        }
        pushStore.translateAllPush(lang, text, pushStore.currentTab, pushStore.setPushTranslations);
    }

    const handleRefreshTranslationText = (translation, index) => {
        const languageCode = translation.languageCode;
        let text = "";
        if (pushStore.currentTab === TabType.title) {
            text = pushStore.title;
        } else {
            text = pushStore.subtitle;
        }
        pushStore.translatePush(index, languageCode, localeStore.locale.toUpperCase(), text, pushStore.currentTab, pushStore.setPushElement)
    }

    const handleChangeSend = async (checked, index) => {
        pushStore.setSend(checked, index);
    }

    const translatingBox = (translation, index) => {
        const languageCode = translation.languageCode;
        return (
            <React.Fragment key={index}>
                {pushStore.getCurrentIndexWithLangCode(localeStore.locale.toUpperCase()) !== index &&
                    <div key={index}>
                        <Box display={'flex'} justifyContent={'space-between'} className={classes.translationTitle}>
                            <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}
                                 style={{width: '10%'}} paddingTop={1}>
                                <Typography
                                    className={classes.langText}>{NoticeLangName[localeStore.locale.toUpperCase()][languageCode]}</Typography>
                                <Button disableRipple onClick={() => handleRefreshTranslationText(translation, index)}>
                                    <TranslationRefreshIcon/>
                                </Button>
                            </Box>
                            <Box>
                                <FormControlLabel
                                    control={<Switch
                                        checked={(translation.isSend === true)}
                                        onChange={(event) => handleChangeSend(translation.isSend, index)}
                                        name="checkedB" className={classes.swichStyle}/>}
                                    label={intl.formatMessage({id: "PushOnOff"})}
                                    labelPlacement="start"
                                />
                            </Box>
                        </Box>
                        <Box>
                            <TextField
                                id="outlined-multiline-static"
                                placeholder={intl.formatMessage({id: "TextPlaceholder"})}
                                variant="outlined"
                                value={translation[pushStore.currentTab]}
                                onChange={(event) => handleTextChange(event, translation)}
                            />
                        </Box>
                    </div>
                }
            </React.Fragment>
        )
    }

    const gobackToPushList = () => {
        history.push(URL_TYPE.Push);
    }

    const handleRegister = async () => {
        if (pushStore.selectOption === PushType.Locale && pushStore.selectLocale === PushType.Select) {
            alert(`${intl.formatMessage({id: "SelectAlert"})}`);
            return;
        }
        if (checked === true && pushStore.reservationDatetime === "") {
            alert(`${intl.formatMessage({id: "ReserveAlert"})}`);
            return;
        }
        if (pushId > 0) {
            if (pushStore.selectOption === PushType.All) {
                await pushStore.updateAllPush(() => history.push(URL_TYPE.Push));
            } else {
                await pushStore.updateLocalePush(() => history.push(URL_TYPE.Push));
            }
        } else {
            if (pushStore.selectOption === PushType.All) {
                await pushStore.createAllPush(() => history.push(URL_TYPE.Push));
            } else {
                await pushStore.createLocalePush(() => history.push(URL_TYPE.Push));
            }
        }

    }

    const disableTitle = !pushStore.title;
    const disableSubtitle = !pushStore.subtitle;
    const disable = !(pushStore.title && pushStore.subtitle);

    return (
        <Box className={classes.root}>
            <Box>
                {/* 푸시 유형 */}
                <Box display={"flex"} justifyContent={"space-between"} marginBottom={3}>
                    <Typography
                        style={{
                            fontWeight: 'bold',
                            fontSize: '1rem'
                        }}>{intl.formatMessage({id: "PushType"})}</Typography>
                    {pushId !== "0" ? (
                        <Box marginRight={2}>
                            <Typography
                                style={{
                                    color: 'red',
                                    fontWeight: 'bold',
                                    textDecoration: 'underline',
                                    cursor: 'pointer'
                                }}
                                onClick={handleOpenDelete}>{intl.formatMessage({id: "delete"})}</Typography>
                            <Modal
                                open={openAlert}
                                onClose={handleCloseDelete}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Box>
                                    <Card style={{
                                        width: '380px',
                                        height: '200px',
                                        backgroundColor: "white",
                                        border: '1px solid black',
                                    }}>
                                        <Box display={"flex"} flexDirection={"column"}>
                                            <Box display={"flex"} flexDirection={"column"} justifyContent={"center"}
                                                 textAlign={"center"} marginTop={5} marginBottom={5}>
                                                <Typography>{intl.formatMessage({id: "msg_info_delete1"})}</Typography>
                                                <Typography>{intl.formatMessage({id: "msg_info_delete2"})}</Typography>
                                            </Box>
                                            <Box display={"flex"} flexDirection={"row"} justifyContent={"center"}>
                                                <Box display={"flex"} justifyContent={"center"}>
                                                    <Button className={classes.setButton1} disableRipple
                                                            onClick={handleCloseDelete}>
                                                        <Typography>{intl.formatMessage({id: "cancel"})}</Typography>
                                                    </Button>
                                                </Box>
                                                <Box display={"flex"} justifyContent={"center"}>
                                                    <Button className={classes.setButton2} disableRipple
                                                            onClick={handleDeletePush}>
                                                        <Typography>{intl.formatMessage({id: "delete"})}</Typography>
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Card>
                                </Box>
                            </Modal>
                        </Box>
                    ) : null}
                </Box>
                {/* 푸시 유형 박스 */}
                <Box className={clsx(classes.boxWrap)}>
                    <Box>
                        {userType === USER_TYPE.Admin ? (
                            <Box>
                                <Box display={"flex"} flexDirection={"row"} paddingBottom={2}>
                                    <Box marginRight={3} display={"flex"} justifyContent={"flex-start"}
                                         alignItems={"center"}>
                                        <input type="radio" id="All" name="options" value={PushType.All}
                                               checked={pushStore.selectOption === PushType.All}
                                               onChange={() => pushStore.setSelectOption(PushType.All)}/>
                                        <label htmlFor="All" style={{
                                            fontWeight: 'bold',
                                            fontSize: '1rem'
                                        }}>{intl.formatMessage({id: "GeneralPush"})}</label>
                                    </Box>
                                    <Box marginRight={1} display={"flex"} justifyContent={"flex-start"}
                                         alignItems={"center"}>
                                        <input type="radio" id="Locale" name="options" value={PushType.Locale}
                                               checked={pushStore.selectOption === PushType.Locale || pushStore.selectOption === PushType.Group}
                                               onChange={() => pushStore.setSelectOption(PushType.Locale)}/>
                                        <label htmlFor="Locale" style={{
                                            fontWeight: 'bold',
                                            fontSize: '1rem'
                                        }}>{intl.formatMessage({id: "LocalPush"})}</label>
                                    </Box>
                                    <Box marginRight={1} display={"flex"} justifyContent={"flex-start"}
                                         alignItems={"center"}>
                                        <FormControl className={classes.formControl}>
                                            <Select
                                                value={pushStore.selectLocale}
                                                onChange={handleChangeLocale}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className: classes.selectPopover
                                                }}
                                            >
                                                {LocaleList.map((type, index) => (
                                                    <MenuItem key={index} value={type.value}
                                                              style={{display: type.value === PushType.Select ? 'none' : 'block'}}>{type.label}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <FormControl className={classes.formControl}>
                                            <Select
                                                value={pushStore.selectGroupId}
                                                onChange={handleChangeGroup}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className: classes.selectPopover
                                                }}
                                            >
                                                <MenuItem value={PushType.All}>{intl.formatMessage({id: "All"})}</MenuItem>
                                                {groupStore.localeGroup.map((type, index) => (
                                                    <MenuItem key={index} value={type.id}>{type.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Box>
                                <Box>
                                    <Typography style={{fontSize: '0.9rem'}}>
                                        {pushStore.selectOption === PushType.All ? intl.formatMessage({id: "GeneralExplanation2"}) : intl.formatMessage({id: "LocalExplanation2"})}
                                    </Typography>
                                </Box>
                                <Box display={"flex"} flexDirection={"row"} marginTop={2} marginBottom={2}
                                     alignItems={"center"}>
                                    <Box marginRight={1}>
                                        <input
                                            type="checkbox"
                                            checked={checked}
                                            onChange={handleChangeCheck}
                                        />
                                    </Box>
                                    <Box marginRight={1}>
                                        <Typography style={{fontSize: '0.9rem'}}>
                                            {intl.formatMessage({id: "reserve"})}
                                        </Typography>
                                    </Box>
                                    <form className={pickerClasses.container} noValidate>
                                        <TextField
                                            id="datetime-local"
                                            label={intl.formatMessage({id: "selectDate"})}
                                            type="datetime-local"
                                            className={pickerClasses.textField}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={pushStore.reservationDatetime || ""}
                                            onChange={(event) => handleReservationDatetime(event)}
                                            disabled={!checked}
                                        />
                                    </form>
                                </Box>
                                {pushStore.selectOption === PushType.All ? (
                                    <Box>
                                        <Typography style={{fontSize: '0.9rem'}}>
                                            {checked ? intl.formatMessage({id: "GeneralExplanation3"}) : intl.formatMessage({id: "GeneralExplanation4"})}
                                        </Typography>
                                    </Box>
                                ) : (
                                    <Box>
                                        <Typography style={{fontSize: '0.9rem'}}>
                                            {checked ? intl.formatMessage({id: "LocalExplanation3"}) : intl.formatMessage({id: "LocalExplanation4"})}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>

                        ) : (
                            <Box>
                                <Box display={"flex"} flexDirection={"row"} paddingBottom={2}>
                                    <Box marginRight={1} display={"flex"} justifyContent={"flex-start"}
                                         alignItems={"center"}>
                                        <Typography
                                            style={{
                                                fontWeight: 'bold',
                                                fontSize: '1rem'
                                            }}>{intl.formatMessage({id: "LocalNotice"})}</Typography>
                                    </Box>
                                    <Box marginRight={1} display={"flex"} justifyContent={"flex-start"}
                                         alignItems={"center"}>
                                        <input className={classes.form} type="text"
                                               value={authStore.loginUser.localeCode} readOnly/>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <FormControl className={classes.formControl}>
                                            <Select
                                                value={pushStore.selectGroupId}
                                                onChange={handleChangeGroup}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className: classes.selectPopover
                                                }}
                                            >
                                                <MenuItem value={PushType.All}>{intl.formatMessage({id: "All"})}</MenuItem>
                                                {groupStore.localeGroup.map((type, index) => (
                                                    <MenuItem key={index} value={type.id}>{type.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Box>
                                <Typography style={{fontSize: '0.9rem'}}>
                                    {intl.formatMessage({id: "LocalExplanation2"})}
                                </Typography>
                                <Box display={"flex"} flexDirection={"row"} marginTop={2} marginBottom={1}
                                     alignItems={"center"}>
                                    <Box marginRight={1}>
                                        <input
                                            type="checkbox"
                                            checked={checked}
                                            onChange={handleChangeCheck}
                                        />
                                    </Box>
                                    <Box>
                                        <Typography style={{fontSize: '0.9rem'}}>
                                            {intl.formatMessage({id: "reserve"})}
                                        </Typography>
                                    </Box>
                                    <form className={pickerClasses.container} noValidate>
                                        <TextField
                                            id="datetime-local"
                                            label={intl.formatMessage({id: "selectDate"})}
                                            type="datetime-local"
                                            className={pickerClasses.textField}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={pushStore.reservationDatetime || ""}
                                            onChange={(event) => handleReservationDatetime(event)}
                                            disabled={!checked}
                                        />
                                    </form>
                                </Box>
                            </Box>
                        )}
                    </Box>
                </Box>
                {/* 내용 */}
                <Box display={"flex"} justifyContent={"space-between"} marginTop={3} marginBottom={3}>
                    <Typography
                        style={{
                            fontWeight: 'bold',
                            fontSize: '1rem'
                        }}>{intl.formatMessage({id: "Content"})}</Typography>
                </Box>
                {/* 내용 박스 */}
                <Box className={clsx(classes.boxWrap)}>
                    <Box>
                        <Box position="static" className={classes.tabBox}>
                            <Tabs value={tabnum} onChange={handleChangeTab} aria-label="simple tabs example">
                                <Tab label={intl.formatMessage({id: "Title"})} {...a11yProps(0)} disableRipple/>
                                <Tab label={intl.formatMessage({id: "subTitle"})} {...a11yProps(1)} disableRipple/>
                            </Tabs>
                        </Box>
                        <TabPanel value={tabnum} index={0}
                                  className={clsx(classes.textBox, classes.textBoxTranslation)}>
                            <TextField
                                id="outlined-static-title"
                                placeholder={`${intl.formatMessage({id: "TitlePlaceholder"})}`}
                                variant="outlined"
                                inputProps={{maxLength: 30}}
                                value={pushStore.title}
                                onChange={handleChangeTitle}
                            />
                            {userType === USER_TYPE.Admin && pushStore.selectOption === PushType.All ? (
                                <Box className={classes.translateButtonArea} display={"flex"}
                                     justifyContent={"flex-end"} >
                                    <Button
                                        disabled={disableTitle}
                                        style={{borderColor: disableTitle ? 'gray' : '#7445FF'}}
                                        variant={'outlined'}
                                        onClick={translateAll}
                                    >
                                        <Typography
                                            style={{color: disableTitle ? 'gray' : '#7445FF'}}>{intl.formatMessage({id: "translation"})}</Typography>
                                    </Button>
                                </Box>
                            ) : null}
                        </TabPanel>
                        <TabPanel value={tabnum} index={1}
                                  className={clsx(classes.textBox, classes.textBoxTranslation)}>
                            <TextField
                                id="outlined-static-subtitle"
                                placeholder={`${intl.formatMessage({id: "SubtitlePlaceholder"})}`}
                                variant="outlined"
                                inputProps={{maxLength: 30}}
                                value={pushStore.subtitle}
                                onChange={handleChangeSubtitle}
                            />
                            {userType === USER_TYPE.Admin && pushStore.selectOption === PushType.All ? (
                                <Box className={classes.translateButtonArea} display={"flex"}
                                     justifyContent={"flex-end"}>
                                    <Button
                                        disabled={disableSubtitle}
                                        style={{borderColor: disableSubtitle ? 'gray' : '#7445FF'}}
                                        variant={'outlined'}
                                        onClick={translateAll}
                                    >
                                        <Typography
                                            style={{color: disableSubtitle ? 'gray' : '#7445FF'}}>{intl.formatMessage({id: "translation"})}</Typography>
                                    </Button>
                                </Box>
                            ) : null}
                        </TabPanel>
                    </Box>
                </Box>
                {
                    userType === USER_TYPE.Admin && pushStore.selectOption === PushType.All ? (
                        <Box>
                            {/* 번역 박스 */}
                            <Box className={classes.boxBottomTranslation}>
                                {pushStore.pushTranslate.length > 0 && pushStore.pushTranslate.map((list, index) => {
                                    if (list.languageCode !== localeStore.locale.toUpperCase()) {
                                        return translatingBox(list, index);
                                    } else {
                                        return null;
                                    }
                                })}
                            </Box>
                        </Box>
                    ) : null
                }
                <Box className={classes.saveButtonArea}>
                    <Button variant={'text'} onClick={gobackToPushList}>
                        <ArrowLeftIcon/>
                        <Typography>{intl.formatMessage({id: "List"})}</Typography>
                    </Button>
                    <Box>
                        <Button disabled={disable}
                                style={{color: 'white', backgroundColor: disable ? 'gray' : '#7445FF'}}
                                variant={'contained'} onClick={handleRegister}>
                            <Typography>{pushStore.id === 0 ? intl.formatMessage({id: "register"}) : intl.formatMessage({id: "modify"})}</Typography>
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default inject('authStore', 'pushStore', 'groupStore', 'localeStore')(injectIntl(observer(PushDetail)));